<template>
  <ModalDefault modal_id="transferTicketModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_716')"
                :footer="chat.ticket_transfer.department_id"
                icon="bx bx-transfer-alt mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block px-2">
              <div class="col-12 pt-0 px-0">
                <label class="mb-0">{{ getTranslations('expression_12') }} </label>
                <div class="input-group mb-3">
                  <select v-model="chat.ticket_transfer.department_id"
                          @change.prevent="chat.ticket_transfer.operator_id = null"
                          class="input_forms custom-select">
                    <option :value="null">{{ getTranslations('expression_124') }}</option>
                    <option v-for="department in getDepartmentsArray('channel_id', chat.ticket.channel_id)"
                            :key="department.id"
                            :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="chat.ticket_transfer.department_id > 0" class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_48') }} </label>
                <div class="input-group mb-2">
                  <select v-model="chat.ticket_transfer.operator_id"
                          @change="walletCheck()"
                          class="input_forms custom-select">
                    <option :value="null">{{ getTranslations('expression_692') }}</option>
                    <option v-for="operator in getOperatorsArray('department_id', chat.ticket_transfer.department_id)"
                            :key="operator.id"
                            :value="operator.id"
                            v-show="
                              (isOperator(chat.ticket_transfer.department_id) !== operator.id
                                && getUserObject('id', operator.user_id).status_key > 0)
                              || getUserObject('id', operator.user_id).status_key == 1">
                      {{ getUserObject('id', operator.user_id).name }}
                    </option>
                  </select>
                </div>
              </div>

<!--              <div v-if="chat.ticket_transfer.department_id &&
                         isOperator(chat.ticket_transfer.department_id) &&
                         chat.ticket_transfer.operator_id &&
                         chat.wallet_check.id > 0"
                   class="col-12 px-0 pb-0">
                <div class="input-group mb-2" style="justify-content: center;">
                  <div v-b-tooltip.top
                       style="justify-content: left; align-self: center;"
                       class="px-3 d-flex cursor_default text-left ellipsis">
                    <div class="pt-0 pb-1 ellipsis">
                      <div class="custom-control d-flex cursor_pointer custom-switch ellipsis">
                        <input type="checkbox"
                               v-model="transfer_wallet"
                               :checked="transfer_wallet"
                               class="custom-control-input ellipsis cursor_pointer"
                               id="check_transfer">
                        <label class="custom-control-label cursor_pointer pt-1 pl-50 ml-2 mr-2"
                               for="check_transfer">
                          <span class="ellipsis ml-1">
                            {{ chat.ticket_transfer.operator_id ?
                            ('Transferir esse lead da sua carteira para ' + getUserObject('id', getOperatorObject('id', chat.ticket_transfer.operator_id).user_id).name) :
                            'Transferir esse lead da sua carteira para o departamento.' }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
        <span @click.prevent="ticketTransfer()"
              data-dismiss="modal"
              class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_538') }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalChatTransferTicket",
  components: {
    ModalDefault,
  },
  data(){
    return {
      transfer_wallet: false
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getDepartmentsArray',
      'getLeadObject',
      'getUserObject',
      'getChannelObject',
      'getDepartmentObject',
      'getOperatorsArray',
      'getOperatorObject',
      'getInterestsArray',
      'getMotivesArray',
    ])
  },
  mounted() {
    this.$root.$on('clearTransfer', () => {
      this.chat.ticket_transfer = {
        operator_id: null,
        department_id: null
      }
    })
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },

    ticketTransfer(){
      this.$store.dispatch('ticketTransfer', {
        // operator_id: this.isOperator(this.chat.ticket.department_id),
        department_id: this.chat.ticket_transfer.department_id,
        operator_id: this.chat.ticket_transfer.operator_id,
        ticket_id: this.chat.ticket.id,
      })
      if (this.transfer_wallet) {
        this.transferWallet()
      }
    },

    async walletCheck(){
      let wallet = {
        operator_id: this.isOperator(this.chat.ticket_transfer.department_id),
        department_id: this.chat.ticket_transfer.department_id,
        channel_id: this.chat.ticket.channel_id,
        lead_id: this.chat.ticket.lead_id
      }

      if(wallet.operator_id > 0 && wallet.department_id > 0 && wallet.lead_id > 0) {
        await this.$store.dispatch('getWalletCheck', wallet)
      }
    },

    transferWallet(wallet) {
      if (this.chat.wallet_check.id > 0) {
        this.$store.dispatch('addWallet', wallet)
      } else {

      }
    },
  }
}
</script>

<style scoped>

</style>
